import React, { Component } from "react";
import axios from "axios";
import Media from "react-media";

import theme from "config/theme";
import { youtubeKey } from "config/keys";

import Loader from "components/Loader";
import { Block } from "components/Grid";
import Icon from "components/Icon";
import Button from "components/Button";

import { Wrapper, Inner, Videos, Footer, Tagline } from "./styles";

import Video from "./Video";

class LatestVideos extends Component {
  state = {
    videos: [],
    isLoading: true
  };

  fetchVideos() {
    const playlistId = "PLuU40xuVo5xDnN_pGRjd6KwrGpsWG-hGN";
    const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=${playlistId}&key=${youtubeKey}&maxResults=4`;

    axios
      .get(url)
      .then(res => {
        this.setState({
          videos: res.data.items,
          isLoading: false
        });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.fetchVideos();
  }

  render() {
    const { videos, isLoading } = this.state;
    const { content, ...props } = this.props;

    return (
      <Wrapper {...props}>
        <Inner>
          {isLoading ? (
            <Loader
              mt="150px"
              mx="auto"
              size="100px"
              color={theme.color.primary}
            />
          ) : videos.length ? (
            <Videos>
              {videos.map((video, index) => (
                <Video content={video} key={index} isFeatured={index === 0} />
              ))}
            </Videos>
          ) : (
            <Loader
              mt="150px"
              mx="auto"
              size="100px"
              color={theme.color.primary}
            />
          )}
        </Inner>
        {content && content.tagline && (
          <Footer>
            <Media query={{ minWidth: theme.size.desktop }}>
              {matches =>
                matches && (
                  <Block>
                    <Icon icon="youtube" size="50px" />
                    <Tagline>{content.tagline}</Tagline>
                  </Block>
                )
              }
            </Media>
            {content.buttonPath && content.buttonText && (
              <Button to={content.buttonPath}>{content.buttonText}</Button>
            )}
          </Footer>
        )}
      </Wrapper>
    );
  }
}

export default LatestVideos;
